module.exports = __webpack_public_path__ + "img/pants.fbcd4cff.jpg";